import theme from '@ublend-npm/aulaui-next-web/themes/default';
import ArrowDropdown from '@material-ui/icons/ArrowDropDown';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import BaseList from '@ublend-npm/aulaui-next-web/List';
import Avatar from '@ublend-npm/aulaui-next-web/Avatar';
import styled from 'react-emotion';
import BaseDivider from '@material-ui/core/Divider';

export const SpaceSelectorContainer = styled.div`
  font-family: ${theme.font.family.workSans};
  font-weight: ${theme.font.weight.regular};
  &:hover {
    cursor: pointer;
    background-color: ${theme.color.blackAlpha(0.08)};
  }
  font-size: 34px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: ${theme.spacing.xxSmall};
  padding-top: ${theme.spacing.xxSmall};
  padding-left: ${theme.spacing.xSmall};
  padding-bottom: ${theme.spacing.xxSmall};
`;

export const SpaceSelectorTarget = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SpaceTitle = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SpaceAvatar = styled(Avatar)`
  min-width: 32px;
  margin-right: 10px;
`;

export const ArrowDropdownIcon = styled(ArrowDropdown)`
  margin-left: ${theme.spacing.xxSmall};
  color: ${theme.color.blackAlpha(0.6)};
`;

export const ArrowForwardIcon = styled(ArrowForwardIosIcon)`
  margin-left: ${theme.spacing.xxSmall};
  font-size: ${theme.font.lineHeight.copy};
`;

export const MenuItemsContainer = styled.div`
  min-width: 300px;
  max-width: 320px;
`;

export const Text = styled.div`
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.copy};
  font-weight: ${theme.font.weight.bold};
  line-height: ${theme.font.lineHeight.copy};
  color: ${theme.color.blackAlpha(0.6)};
  padding-top: ${theme.spacing.small};
  padding-bottom: ${theme.spacing.small};
  padding-left: 28px;
`;

export const List = styled(BaseList)`
  overflow: scroll;
  flex: 1;
`;

export const Divider = styled(BaseDivider)`
  margin-right: 12px;
  margin-left: 12px;
`;

export const SpacesWithStaffButton = styled.div`
  padding-left: ${theme.spacing.xxLarge};
  padding-right: ${theme.spacing.xxLarge};
  padding-top: ${theme.spacing.large};
  padding-bottom: ${theme.spacing.large};
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.copy};
  font-weight: ${theme.font.weight.bold};
  line-height: ${theme.font.lineHeight.copy};
  color: ${theme.color.designSystem.purple70};
  display: flex;
  justify-content: space-between;
  :hover {
    background: ${theme.color.purple2};
    cursor: pointer;
  }
`;
